import Flux from 'lib/flux';
import ConversationService from 'services/conversation';
import ConversationConstants from 'constants/conversation';

const ConversationActionCreator = Flux.createActionCreator({
  create_from_booking(params, successCallback, failureCallback) {
    let onFullfilled;
    let onRejected;
    const _this = this;
    this.dispatchAction(ConversationConstants.CREATE);

    onFullfilled = function (resp) {
      _this.dispatchAction(ConversationConstants.CREATE_COMPLETED, resp);
      successCallback(resp);
    };

    onRejected = function (errors) {
      _this.dispatchAction(ConversationConstants.CREATE_FAILED, errors);
      failureCallback(errors.message);
    };

    ConversationService.create_from_booking(params).then(
      onFullfilled,
      onRejected
    );
  },
});

export default ConversationActionCreator;
